import React, {useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent, ToggleComponent} from '../../../assets/ts/components'
import { AsideMenuItem } from './AsideMenuItem'
import { useIntl } from 'react-intl'

type Props = {
  asideMenuCSSClasses: string[]
  onKeepAsideOpen: () => void
}

const AsideMenu: React.FC<Props> = ({asideMenuCSSClasses,onKeepAsideOpen,}) => {
  const {pathname} = useLocation();
  const intl = useIntl();
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation()
    onKeepAsideOpen()
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
    }, 50)
    return () => clearTimeout(timer)
  }, [pathname])

  return (
    <div
      id="kt_aside_menu_wrapper"
      className={['hover-scroll-overlay-y my-2 my-lg-5 pe-lg-n1',
        ...(asideMenuCSSClasses ?? [])
      ].join(' ')}
    >
      <div
        className='menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500'
        id='#kt_aside_menu'
        data-kt-menu='true'
      >
        <div
          className="reset-button d-flex justify-content-center flex-column"
          onClick={stopPropagation}
        >
          <AsideMenuItem
            to='/dashboard'
            title="Home"
            icon='media/ATR/icons/Nav-Home.png'
            bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            className=''
          />
        </div>
        <div
          className="reset-button d-flex justify-content-center flex-column"
          onClick={stopPropagation}
        >
          <AsideMenuItem
            to='/orders/report'
            title="Report"
            icon='media/ATR/icons/Nav-Report.png'
            bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            className=''
          />
        </div>
        <div
          className="reset-button d-flex justify-content-center flex-column"
          onClick={stopPropagation}
        >
          <AsideMenuItem
            to='/orders/new'
            title='Add Order'
            icon='media/ATR/icons/Nav-add-order.png'
            bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            className=''
          />
        </div>
        <AsideMenuItem
          to=''
          title={'Resources'}
          icon='media/ATR/icons/Nav-info.png'
          bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          className=''
          resource={true}
        />
        <AsideMenuItem
          to=''
          title={'Settings'}
          icon='media/ATR/icons/Nav-Settings.png'
          bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          className=''
          settings={true}
        />
        <div
          className="reset-button d-flex justify-content-center flex-column"
          onClick={stopPropagation}
        >
          <AsideMenuItem
            to='/faqs'
            title='FAQ'
            icon='media/ATR/icons/Icon feather-help-circle.svg'
            bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            className=''
          />
        </div>
      </div>
    </div>
  )
}

export {AsideMenu}
